export class AnswerWithMoreInfoModel {
  answerState: AnswerStateEnum;
  navigateTo: NavigateToEnum;
  message: string;
  entity: any;
}

export enum AnswerStateEnum {
  OK = 'OK',
  ERROR = 'ERROR'
}

export enum NavigateToEnum {
  none = 'none',
  goToErrorPage = 'goToErrorPage',
  goToThanksPage = 'goToThanksPage'
}
